import * as React from 'react';

import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Button } from 'react-bootstrap';
import {IconButton, View, rem} from './../libs/WebComponents';
import { wpAuthPOST } from '../api/api-user';
import { HandleFetchError } from '../api/api-root';
import { WpPage } from '../App';
import IconButtonShadow from './IconButtonShadow';

export interface UserPhoto {
   filepath: string;
   webviewPath?: string;
 }

const PhotoUploader = (props: {page: WpPage, group_id: number, onClose: Function, uploadDone: Function})=>{

   const { photos, takePhoto } = usePhotoGallery();
   const [loading, setLoading] = React.useState(false);
   const [isSuccess, setIsSuccess] = React.useState(false);

   const savePhoto = async () => {
      const fileName = 'g'+props.group_id + '-q' + props.page.ID + '-' + new Date().getTime() + '.jpg';
      setLoading(true);
      try{
         const results: any | {success: boolean} = await wpAuthPOST('user/uploadphotos', {question_id: props.page.ID, photos:[{base64:photos[0].base64String, fileName}]});
         if (results && results.success)
         {
            setIsSuccess(true);
            props.uploadDone('data:image/png;base64, '+photos[0].base64String);
         }
      }catch(err: HandleFetchError | any)
      {
         console.warn(err);
      }finally{
         setLoading(false);
      }
   };




   return (
      <View style={{width: 'inherit', height:'inherit', position: 'relative'}}>
         <View style={{position:'relative', display:'block', maxHeight:'60vh',maxWidth:'90vw', margin:'5rem auto 2rem auto', aspectRatio:'16 / 10', backgroundColor:'var(--color-gray-lightest)', overflow:'hidden'}}>
            {photos.map((photo: Photo, index: number) => (
            <View style={{width:'100%',height:'100%'}} key={index}>
               <img src={'data:image/png;base64, '+photo.base64String} style={{width:'100%',height:'100%',objectFit:'contain'}} />
            </View>
            ))}
          {isSuccess || loading?<View style={{position:'absolute', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,.3)', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <IconButtonShadow animate shadow={'var(--color-green)'} color={'var(--color-white)'} iconColor={loading?'var(--color-purple)':'var(--color-green)'} iconSize={rem(4.5)} size={rem(6)} name={loading?'Loader':'Check'} containerClassName={loading?'spin':''} containerStyle={{maxHeight:rem(8)}} />
            <span style={{color:'var(--color-white)', fontSize:rem(2), paddingTop:rem(1), paddingBottom:rem(1)}}>{loading?'Foto verzenden':'Foto verzonden'}</span>
            {!loading?<Button className={'btn-white'} onClick={()=>props.onClose()} style={{margin:rem(.3), color:'var(--color-black)',border:'.1rem solid var(--color-gray-lightest)'}}>Sluit venster</Button>:null}
            </View>:null}
         </View>
         {!isSuccess?<View style={{flexDirection:'row', flex:0,padding:rem(2), justifyContent:'center', width:'100%'}}>
            <Button disabled={loading} style={{margin:rem(.3)}} onClick={()=>photos && photos.length>0 ? savePhoto() : takePhoto()}>{photos && photos.length>0 ? 'Verzend foto':'Kies foto'}</Button>
            <Button className={'btn-white'} onClick={()=>props.onClose()} style={{margin:rem(.3), color:'var(--color-black)',border:'.1rem solid var(--color-gray-lightest)'}}>Annuleer</Button>
         </View>:null}
      </View>
   );


};


export function usePhotoGallery() {

   const [photos, setPhotos] = React.useState<Photo[]>([]);

   const takePhoto = async () => {
      const photo = await Camera.getPhoto({
         resultType: CameraResultType.Base64,
         source: CameraSource.Camera,
         quality: 90,
      });

      const newPhotos: Photo[] = [photo];
      setPhotos(newPhotos);
   };

   return {
      photos,
      takePhoto,
   };

}

export default React.memo(PhotoUploader);
